import type { OwnerResource } from "../../owner";
import type { SupplierOrderPositionResource } from "../../supplier-order-position";

export type SupplierOrderTypeEnum =
  | "commission"
  | "purchased"
  | "dropshipper"
  | "justintime"
  | "exonn_hub";

export enum SupplierOrderStatusEnum {
  New = "new",
  Sent = "sent",
  PartiallySent = "partially_sent",
  PartiallyProcessed = "partially_processed",
  Processed = "processed",
  Cancelled = "cancelled",
}

export interface SupplierOrderResource {
  id: string;
  gid: string;
  supplier: string;
  order_type: SupplierOrderTypeEnum;
  owner_id: string | null;
  owner_profile_id: string | null;
  owner?: OwnerResource;
  order_date: string;
  order_number: string;
  owner_hashed_address_id: string | null;
  status: SupplierOrderStatusEnum;
  text_start: string;
  text_end: string;
  delivery_address_id: string | null;
  delivery_phone: string;
  delivery_email: string;
  total_price: string;
  currency: string;
  appointment_date: string | null;
  production_days: number | null;
  delivery_days: number | null;
  delivery_cost_type: string;
  delivery_cost_value: string | null;
  supplier_order_positions?: SupplierOrderPositionResource[];
  supplier_order_positions_count?: number;
  total_gross_price: number;
  order_summary: Record<
    string,
    {
      gross_price: number;
      net_price: number;
      tax_sum: number;
      vat_percent: number;
    }
  >;
}

export type UpdateSupplierOrderRequestBody = {
  owner_profile_id: number;
};

export type StoreSupplierOrderRequestBody = {
  order_type?: SupplierOrderTypeEnum;
  owner_profile_id: string;
};
